import clientConfig from '@v2/config/client'

let platform = {
  getPlatformId: function () {
    let origin = window.location.origin
    for (let platformId in clientConfig.origin) {
      if (origin.indexOf(clientConfig.origin[platformId]) >= 0) {
        return platformId
      }
    }
    return '1'
  },
  id: global.PLATFORMID,
  qdIds: ['1', '3'],
  qqIds: ['2'],
  androidIds: ['1', '2'],
  iosIds: ['3'],
  isCommonWeb: function () {
    let useragent = navigator.userAgent.toLocaleLowerCase()
    if (useragent.indexOf('qd') < 0 && useragent.indexOf('qq') < 0) {
      return true
    } else {
      return false
    }
  },
  isQd: function () {
    if (platform.qdIds.indexOf(global.PLATFORMID) >= 0) {
      return true
    } else {
      return false
    }
  },
  isQq: function () {
    if (platform.qqIds.indexOf(global.PLATFORMID) >= 0) {
      return true
    } else {
      return false
    }
  },
  isAndroid: function () {
    if (platform.androidIds.indexOf(global.PLATFORMID) >= 0) {
      return true
    } else {
      return false
    }
  },
  isIos: function () {
    if (platform.iosIds.indexOf(global.PLATFORMID) >= 0) {
      return true
    } else {
      return false
    }
  }
}

export default platform



// WEBPACK FOOTER //
// ./src/v2/static/client/platform.js